import { Col, Container, Row } from "react-bootstrap";

import { Fragment, useState } from "react";

import Banner from "../components/Banner/Banner";
import useWindowScrollToTop from "../hooks/useWindowScrollToTop";
import Return from "../components/Aboutus/Return";


const ReturnPage = () => {

  useWindowScrollToTop();

  return (
    <Fragment>
      <Banner title="Return Policy" />
   
        <Container className="filter-bar-contianer">
          
        </Container>
        <Container>
         <Return/>
        
        </Container>
 
    </Fragment>
  );
};

export default ReturnPage;
